import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle, Scissors } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../store/AuthContext";

export default function PaymentResultPage({ cancelled = false }) {
  const { refresh } = useAuth();
  const [status, setStatus] = useState(cancelled ? "cancelled" : "checking");
  useEffect(() => {
    if (cancelled) return;
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0, stop = false;
    const poll = async () => {
      try {
        const r = await api.paymentStatus(sid);
        if (r.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (["expired", "failed"].includes(r.payment_status)) { setStatus("error"); return; }
      } catch { /* retry */ }
      if (!stop && ++tries < 10) setTimeout(poll, 2000); else if (!stop) setStatus("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [cancelled, refresh]);
  const home = () => window.location.assign("/");
  const box = { paid: ["Subscription active — welcome to Xpattern Pro!", "Your plotter is ready to cut without limits.", CheckCircle2, "text-[#3ecf8e]"],
    checking: ["Confirming your payment…", "This takes a few seconds.", Loader2, "text-[#9aa0a8]"],
    cancelled: ["Checkout cancelled", "No charge was made. You can subscribe any time from your account menu.", XCircle, "text-[#f5a524]"],
    timeout: ["Still processing", "Your payment is being confirmed. Check your account in a minute.", Loader2, "text-[#f5a524]"],
    error: ["Payment not completed", "Nothing was charged. Please try again.", XCircle, "text-[#e5484d]"] }[status];
  const Icon = box[2];
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[#0c1017] px-6 text-[#e8e9ec]" data-testid="payment-result-page">
      <div className="w-full max-w-sm space-y-4 rounded-lg border border-[#27324a] bg-[#121824] p-6 text-center">
        <Icon className={`mx-auto h-8 w-8 ${box[3]} ${status === "checking" ? "animate-spin" : ""}`} />
        <div className="text-[15px] font-semibold" data-testid="payment-result-title">{box[0]}</div>
        <p className="text-[12px] text-[#9aa0a8]">{box[1]}</p>
        <button data-testid="payment-back-btn" onClick={home} className="btn-red w-full"><Scissors className="h-4 w-4" /> Back to Xpattern</button>
      </div>
    </div>
  );
}
